<template>
    <el-dialog
        title="分账规则"
        :visible.sync="visible"
        width="1500px"
        :before-close="handleClose"
    >
        <div class="sales-rule-dialog">
            <SalesRuleTeam
                :defaultExpandAll="true"
                :data="teamData"
                @nodeClick="handleNodeClick"
                ref="salesRuleTeamRef"
            >   
                <template v-slot:extra="{ data }">
                    <span v-if="data.saleStatus === 1">在售</span>
                    <span v-else-if="data.saleStatus === 2">停售</span>
                    <span v-else>未知</span>
                </template>
            </SalesRuleTeam>
            <RuleLook
                :nodesData="detailTree" 
            ></RuleLook>
        </div>
    </el-dialog>
</template>
0
<script>
import RuleLook from "@/components/CbSalesRuleG6/RuleLook.vue"
import SalesRuleTeam from "./salesRuleTeam.vue"
import { 
    teamUsedRuleSys,
    queryOrgStructureByAdplanId
} from "@/api/saleRule/agent"
export default {
    name: 'SalesRuleDialog',
    components: {
        RuleLook,
        SalesRuleTeam
    },
    data() {
        return {
            visible: false,
            detailTree: [],
            teamData: [],
            adPlanId: ''
        }
    },
    created() {
        
    },
    methods: {
        publicOpen(e) {
            const { adPlanId } = e
            if(!adPlanId)return
            this.adPlanId = adPlanId
            this.visible = true
            this.requestTreeData()
        },
        requestTreeData() {
            try {
                queryOrgStructureByAdplanId(this.adPlanId).then(res => {
                    if(res && res.children){
                        this.teamData = res.children
                        this.requestData(res.children[0].id)
                        this.$nextTick(() => {
                            this.$refs.salesRuleTeamRef.publicSetCurrentNodeKey(res.children[0].id)
                        })
                            
                    }else{
                        this.teamData = []
                    }
                })
            } catch (error) {
                this.teamData = []
            }
        },
        requestData(id) {
            try {
                teamUsedRuleSys(id).then(res => {
                    if(!res ||!res.detailTree){
                        this.detailTree = []
                        return
                    }
                    this.dealDetailTree([res.detailTree])
                })
            } catch (error) {
                this.detailTree = []
            }
        },
        handleClose() {
            this.visible = false
        },
        // 处理分账规则详情
        dealDetailTree(data){
            // 遍历树，变成一维数组
            let arr = []
            const loop = (data) => {
                data.forEach((item) => {
                    arr.push(item)
                    if (item && item.children && item.children.length) {
                        loop(item.children)
                    }
                })
            }
            loop(data)
            this.detailTree =  arr
        },
        handleNodeClick(data) {
            this.requestData(data.id)
        }

    }
}
</script>
<style scoped lang="scss">
.sales-rule-dialog {
    display: flex;
    height: 100%;
}
</style>